export const iconsEffects = {
  hover: {
    scale: 1.5
  },
  whileTap: {
    scale: 0.5
  },
  trans: {
    type: 'spring', stiffness: 300
  }
}